/**
 * Torso outfits registry index
 */
import { vietnamese_drawers } from './vietnamese.js';
import { ride_hailing_drawers } from './ride-hailing.js';
import { formal_drawers } from './formal.js';
import { alien_elemental_1_drawers } from './alien-elemental-1.js';
import { alien_elemental_2_drawers } from './alien-elemental-2.js';
import { alien_cosmic_1_drawers } from './alien-cosmic-1.js';
import { alien_cosmic_2_drawers } from './alien-cosmic-2.js';
import { alien_cosmic_3_drawers } from './alien-cosmic-3.js';
import { alien_mythic_1_drawers } from './alien-mythic-1.js';
import { alien_mythic_2_drawers } from './alien-mythic-2.js';
import { alien_mythic_3_drawers } from './alien-mythic-3.js';

export const TORSO_REGISTRY = {
  ...vietnamese_drawers,
  ...ride_hailing_drawers,
  ...formal_drawers,
  ...alien_elemental_1_drawers,
  ...alien_elemental_2_drawers,
  ...alien_cosmic_1_drawers,
  ...alien_cosmic_2_drawers,
  ...alien_cosmic_3_drawers,
  ...alien_mythic_1_drawers,
  ...alien_mythic_2_drawers,
  ...alien_mythic_3_drawers
};
